<div class="page">
  <app-page-header page-title="deadlines.subscriptionsList.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'deadlines.subscriptionsList.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportDeadlines')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                  <button mat-raised-button (click)="onRenewDeadlines()" color="primary" *ngIf="roleAdmin">
                    <mat-icon fontSet="fal" fontIcon="fa-repeat"></mat-icon>
                    {{ 'deadlines.fields.renew' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="endDate"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="hasNotes">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs"></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button mat-icon-button (click)="onOpenNotes(element._id)" *ngIf="element.hasNotes">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-exclamation" color="primary"></mat-icon>
                    </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="property">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.property' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../../properties/{{ element._id}}/home">
                      {{ element.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter" [matAutocomplete]="propertyAuto">
                      <mat-autocomplete autoActiveFirstOption #propertyAuto="matAutocomplete"
                        [displayWith]="displayFn.bind(this)" (onSelectionChange)="onPropertyFilterSelected($event)">
                        <mat-option *ngIf="propertyIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!propertyIsLoading">
                          <mat-option *ngFor="let property of availableProperties" [value]="property"
                            (onSelectionChange)="onPropertyFilterSelected($event)">
                            <small>{{ property.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="masterCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'properties.fields.masterCode' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.masterCode || ('common.words.dashes' | translate) }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="masterCodeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(masterCodeFilter)"
                        class="reset-input-icon" *ngIf="masterCodeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscription">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.subscription' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.subscription && element.subscription.key !== 'noSubscription'">{{ element.subscription?.key }}</span>
                    <span *ngIf="element.subscription && element.subscription.key === 'noSubscription'">SAG</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <mat-select [formControl]="subscriptionFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option *ngFor="let subscription of availableSubscriptions" [value]="subscription.value">
                          {{ subscription.label }}
                        </mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(subscriptionFilter)"
                        class="reset-input-icon" *ngIf="subscriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="forfait">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.forfait' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.subscription?.forfait }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <mat-select [formControl]="forfaitFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="true">{{ 'common.words.yes' | translate }}</mat-option>
                        <mat-option value="false">{{ 'common.words.no' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(forfaitFilter)"
                        class="reset-input-icon" *ngIf="forfaitFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="options">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.options' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.subscription?.options }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <mat-select [formControl]="optionsFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <!-- <mat-option value="all">{{ 'deadlines.subscriptionsList.options.all' | translate }}</mat-option> -->
                        <mat-option value="qrcode">{{ 'deadlines.subscriptionsList.options.qrcode' | translate }}</mat-option>
                        <!-- <mat-option value="qrcodeNfc">{{ 'deadlines.subscriptionsList.options.qrcodeNfc' | translate }}</mat-option> -->
                        <mat-option value="dossierQrcode">{{ 'deadlines.subscriptionsList.options.dossierQrcode' | translate }}</mat-option>
                        <!-- <mat-option value="dossierNfc">4 {{ 'deadlines.subscriptionsList.options.dossierNfc' | translate }}</mat-option> -->
                        <!-- <mat-option value="nfc">5 {{ 'deadlines.subscriptionsList.options.nfc' | translate }}</mat-option> -->
                        <mat-option value="dossier">{{ 'deadlines.subscriptionsList.options.dossier' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(optionsFilter)"
                        class="reset-input-icon" *ngIf="optionsFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.date' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.subscription.endDate | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="endDateFilter"
                        style="cursor: pointer" />
                      <!-- <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(endDateFilter)"
                        class="reset-input-icon" *ngIf="endDateFilter.value"></mat-icon> -->
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp
                        startView="multi-year"
                        (yearSelected)="chosenYearHandler($event)"
                        (monthSelected)="chosenMonthHandler($event, dp)">
                      </mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="invoiceDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.invoiceDate' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.subscription.invoiceDate | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="invoiceDateFilter"
                        style="cursor: pointer" />
                      <!-- <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(invoiceDateFilter)"
                        class="reset-input-icon" *ngIf="invoiceDateFilter.value"></mat-icon> -->
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp
                        startView="multi-year"
                        (yearSelected)="chosenYearInvoiceHandler($event)"
                        (monthSelected)="chosenMonthInvoiceHandler($event, dp)">
                      </mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalDoc">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.totalDoc' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.subscription && element.subscription.totalDoc">{{ element.subscription?.totalDoc }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <mat-select [formControl]="totalDocFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="under">{{ 'deadlines.subscriptionsList.totalDoc.under' | translate }}</mat-option>
                        <mat-option value="above">{{ 'deadlines.subscriptionsList.totalDoc.above' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(totalDocFilter)"
                        class="reset-input-icon" *ngIf="totalDocFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="adminCompany">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    title="{{ 'properties.fields.admin' | translate }}">
                    {{ 'properties.fields.admin' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../../companies/detail/{{ element.admin.company._id }}" *ngIf="element.admin && element.admin.company">
                      {{ element.admin?.company?.name }}  
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="adminCompanyFilter" [matAutocomplete]="adminAuto">
                      <mat-autocomplete autoActiveFirstOption #adminAuto="matAutocomplete"
                        [displayWith]="displayAdminFn.bind(this)"
                        (onSelectionChange)="onAdminCompanyFilterSelected($event)">
                        <mat-option *ngIf="adminIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!adminIsLoading">
                          <mat-option *ngFor="let admin of availableAdmins" [value]="admin"
                            (onSelectionChange)="onAdminCompanyFilterSelected($event)">
                            <small>{{ admin.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(adminCompanyFilter)"
                        class="reset-input-icon" *ngIf="adminCompanyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.words.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                        class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container> -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <mat-checkbox [checked]="element.checked"
                      (change)="onSubsSelected(element, $event.checked)" class="checkbox-insert">
                    </mat-checkbox>
                    <!-- <a (click)="onOpenDialog(element)" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </a> -->
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->